import {Api} from '../../Api.js'

const RESOURCE = 'company'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    all(query) {
        return Api().get(this.resource + '/all'  + (query ? query : '') )
    }
}


// WEBPACK FOOTER //
// ./src/modules/company/CompanyService.js